module.exports = __webpack_public_path__ + "img/companyus.43bfb81f.png";